export const NO_CELL_SELECTED = {
  rowIndex: undefined,
  columnIndex: undefined,
  cellData: undefined,
};
